import './share.scss'

import {
	BlueskyIcon,
	FacebookIcon,
	LinkIcon,
	MailIcon,
	MessengerIcon
} from 'styles/inline-icons'
import {ClassName, Mod, style} from 'util/campagne/style'
import React, {FunctionComponent, ReactElement, useState} from 'react'
import {facebookLink, mailLink, messengerLink} from 'util/share'

import {ButtonShare} from 'views/ui/Button'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {useTranslation} from 'util/i18n'

const styles = style('share', ['container', 'link'])
type ShareMods = Mod<'with_border'>

export const ShareContainer: FunctionComponent<{mod?: ShareMods}> = ({
	children,
	mod,
	...props
}) => (
	<div class={styles.container.mod(mod)} {...props}>
		{children}
	</div>
)

export const ShareLink: FunctionComponent<{
	icon: ReactElement
	target?: '_self' | '_blank'
	className?: string | ClassName
	mod?: string
	href?: string
	style?: React.CSSProperties
}> = ({target = '_blank', children, icon, className, mod, style, ...props}) => (
	<a
		class={styles.link.mod(mod).with(className)}
		target={target}
		style={style}
		{...props}
	>
		{icon}
	</a>
)

export const ShareIcons: FunctionComponent<{
	mod?: ShareMods
	copy?: string
}> = ({copy, mod}) => {
	const [isCopied, setCopied] = useState(false)
	const t = useTranslation('campagne').action
	return (
		<ShareContainer mod={mod}>
			<CopyToClipboard
				text={
					window.location.protocol +
					'//' +
					window.location.host +
					window.location.pathname
				}
				onCopy={() => setCopied(true)}
			>
				<div>
					<ShareLink
						className={styles('sharelink').is({copied: isCopied}).toString()}
						icon={<LinkIcon />}
					/>
					<span class={styles('sharelink-feedback').is({visible: isCopied})}>
						{t.copied}
					</span>
				</div>
			</CopyToClipboard>
			<ShareLink {...sharePlatform('mail')} icon={<MailIcon />} />
			<ShareLink
				mod="messenger"
				{...sharePlatform('messenger')}
				icon={<MessengerIcon />}
			/>
			<ShareLink {...sharePlatform('facebook')} icon={<FacebookIcon />} />
			<ShareLink {...sharePlatform('bluesky', copy)} icon={<BlueskyIcon />} />
		</ShareContainer>
	)
}

export const sharePlatform = (type, desc = null) => {
	const splittedUrl = window.location.href.split(/[?#]/)[0]
	if (!type) return null
	switch (type) {
		case 'facebook':
			return facebookLink(splittedUrl)
		case 'messenger':
			return messengerLink(splittedUrl)
		case 'mail':
			return mailLink(splittedUrl)
	}
}

export const Share: FunctionComponent<{
	mod?: ShareMods
	copy?: string
	text: string
}> = ({mod, text, copy}) => {
	const [isVisible, setVisible] = useState(false)
	return (
		<div class={styles.is({visible: isVisible})}>
			<span class={styles('button')} onClick={() => setVisible(!isVisible)}>
				<ButtonShare>{text}</ButtonShare>
			</span>
			<span class={styles('icons')}>
				<ShareIcons copy={copy} mod={mod} />
			</span>
		</div>
	)
}
